export default __webpack_public_path__ + "static/media/Chat start illustration.b73e49e8.svg";